import { ApiClient } from '@k2/common/backend/api-client';

export class UsersEndpoint {
  constructor(private api: ApiClient) {}

  deleteUser = (userId: number) => {
    return this.api.delete(`/user/${userId}`);
  };
}
